/**
 * OnboardingTypeDetector - Helper to determine current onboarding context
 * Adapted for React Native environment where we don't have URL paths like web
 */

export type OnboardingType = 'app_onboarding' | 'web_onboarding' | 'unknown';

export const detectOnboardingType = (): OnboardingType => {
  // In React Native app context, we mostly deal with the app onboarding
  return 'app_onboarding';
};

